"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
exports.default = vue_1.default.extend({
    name: 'Button',
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            validator: function (align) { return ['right', 'left', 'center'].includes(align); },
            required: false,
            default: 'center',
        },
        size: {
            type: String,
            default: 'normal',
            validator: function (item) { return ['tiny', 'small', 'normal', 'big', 'jumbo'].includes(item); },
        },
        rounded: {
            type: Boolean,
            default: true,
        },
        disableOnServerBusy: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'normal',
            validator: function (item) {
                return [
                    'normal',
                    'action',
                    'max',
                    'success',
                    'error',
                    'submit',
                    'close',
                    'back',
                    'minus',
                    'plus',
                ].includes(item);
            },
        },
    },
    computed: {
        isDisabledDueToServerBusy: function () {
            return this.disableOnServerBusy && this.$root.isServerSideRequestInProgress;
        },
        isDisabled: function () {
            return this.disabled || this.isDisabledDueToServerBusy;
        },
        hasIcon: function () {
            var iconTypes = ['close', 'back', 'plus', 'minus'];
            return iconTypes.includes(this.type);
        },
        outerClass: function () {
            return {
                'btn-tiny': this.size === 'tiny',
                'btn-sm': this.size === 'small',
                'btn-lg': this.size === 'big',
                'btn-max': this.type === 'max',
                'btn-plus': this.type === 'plus',
                'btn-minus': this.type === 'minus',
                'btn-success': this.type === 'success',
                'btn-error': this.type === 'error',
                'btn-action': this.type === 'action',
                'btn-submit': this.type === 'submit',
                'float-left': this.align === 'left',
                'float-right': this.align === 'right',
                'btn-rounded': this.rounded === true,
                'loading': this.isDisabledDueToServerBusy,
            };
        },
        iconClass: function () {
            return {
                'icon-cross': this.type === 'close',
                'icon-back': this.type === 'back',
                'icon-plus': this.type === 'plus',
                'icon-minus': this.type === 'minus',
            };
        },
    },
});
